function JoyTycoonTimerBox(config) {
  myPixiElement.container.call(this);


  this.config = $.extend(true,{
        img:"timerBox",
        howlong:0,
        capText:"TIME!",
        pos:[0,0],
        text_conf:{
            cap:{
                font_color:"#c0ff00",
                font_size:22,
                border_color:"#500f46",
                border_size:4,
                pos:[35,18],
            },
            desc:{
                font_color:"#c0ff00",
                font_size:36,
                border_color:"#500f46",
                border_size:4,
                pos:[35,49],
            },
        },
        onEnd:function(){
            
        }
        
  },config);
  this.x=this.config.pos[0];
  this.y=this.config.pos[1];
  this.storage={
      delta_sum:0,
      howlong_last:this.config.howlong
  };
  
  this.init();
  
}
JoyTycoonTimerBox.prototype = Object.create(myPixiElement.container.prototype);
JoyTycoonTimerBox.prototype = $.extend(JoyTycoonTimerBox.prototype, {
    init:function(){
        var obj=new myPixiElement.img({img:this.config.img,anchor:[0.5,0]});
        this.addChild(obj);
        var textConf=this.config.text_conf.cap;
        var capText=new myPixiObj.showText(this.config.capText,{
            pos:textConf.pos,
            font_color:textConf.font_color,
            font_size:textConf.font_size,
            border_color:textConf.border_color,
            border_size:textConf.border_size,
        });
        this.addChild(capText);
        textConf=this.config.text_conf.desc;
        this.textObj=new myPixiObj.showText(this.config.howlong,{
            pos:textConf.pos,
            font_color:textConf.font_color,
            font_size:textConf.font_size,
            border_color:textConf.border_color,
            border_size:textConf.border_size,
        });
        this.addChild(this.textObj);
    },
    takeTimeRemain:function(){
        return this.storage.howlong_last;
    },
    addHowlong:function(howlong){
        this.config.howlong+=howlong;
        this.update(0);
    },
    update:function(delta){
        this.storage.delta_sum+=delta;
        var howlong=this.config.howlong-this.storage.delta_sum/60;
        howlong=Math.ceil(howlong);
        howlong=Math.max(0,howlong);
        if(howlong!=this.storage.howlong_last){
            this.textObj.changeText(howlong);
            this.storage.howlong_last=howlong;
            if(howlong==0){
                this.config.onEnd.call(this);
            }
        }
    }
});

